import { Card, CircularProgress, Collapse, Icon, Tooltip } from "@mui/material";
import SinDatos from "components/Carteles/SinDatos";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { memo, use, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import EmpleadoDetalle from "./EmpleadoDetalle";
import { useMutation, gql } from "@apollo/client";
import dayjs from "dayjs";
import { MessageManager } from "context";

const SAVE_PEDIDO_INTERNO = gql`
  mutation SavePedidoInterno($input: PedidoInternoInput!) {
    savePedidoInterno(input: $input) {
      id
    }
  }
`;

function ListDetallesConsumoInterno({ pedido, setPedido, setEmpleadoSelected, handleSuccess, dataGeneral }) {
    const [savePedidoInterno, { loading: loadingSave }] = useMutation(SAVE_PEDIDO_INTERNO);
    const pedidoOriginal = useRef(null);
    const { handleSnackbar } = useContext(MessageManager);

    useEffect(() => {
        if (!pedidoOriginal.current && pedido && pedido.length > 0) {
            pedidoOriginal.current = JSON.stringify(pedido);
        }
    }, [pedido]);

    const handleUpdateEstado = useCallback((
        idEmpleado,
        item,
        newEstado,
        motivoCancelacion = "",
        options = {}
    ) => {
        if (options.removeEmpleado) {
            if (options.removeEmpleado) {
                setEmpleadoSelected(null);
                setPedido(prev => {
                    const empleado = prev.find(emp => emp.idEmpleado === idEmpleado);

                    if (!empleado) return prev;

                    if (empleado.idDetalle) {
                        return prev.map(emp => {
                            if (emp.idEmpleado === idEmpleado) {
                                return {
                                    ...emp,
                                    deleted: 1,
                                    detalles: (emp.detalles || []).map(det => ({
                                        ...det,
                                        estado: newEstado,
                                        motivoCancelacion: "CANCELADO",
                                    })),
                                };
                            }
                            return emp;
                        });
                    } else {
                        return prev.filter(emp => emp.idEmpleado !== idEmpleado);
                    }
                });
                return;
            }
        }


        const updatedPedido = pedido.map((emp) => {
            if (emp.idEmpleado === idEmpleado) {
                return {
                    ...emp,
                    detalles: (emp.detalles || []).map((det) =>
                        det.producto.id === item?.producto?.id &&
                            item.precio === det.precio &&
                            item.precioEditado === det.precioEditado &&
                            item.cantidad === det.cantidad &&
                            item.estado === det.estado
                            ? {
                                ...det,
                                estado: newEstado,
                                motivoCancelacion: newEstado === "CANCELADO" ? "CANCELADO" : det.motivoCancelacion,
                            }
                            : det
                    ),
                };
            }
            return emp;
        });

        setPedido(updatedPedido);
    }, [pedido, setPedido, setEmpleadoSelected]);

    const hayCambios = useMemo(() => {
        if (!pedido || pedido.length === 0) return false;
        if (!pedidoOriginal.current) return false;
        return pedidoOriginal.current !== JSON.stringify(pedido);
    }, [pedido]);

    if (!pedido || pedido.length < 1) {
        return <SinDatos mensaje="No hay empleados ni productos registrados." />;
    }

    const handleSave = async () => {
        try {
            const input = {
                id: dataGeneral?.id || null,
                total: pedido.reduce((sum, emp) =>
                    sum + ((emp.detalles || []).reduce((cSum, cons) =>
                        cSum + ((cons.precioEditado ?? cons.precio ?? 0) * cons.cantidad), 0) || 0), 0),
                fechaPedido: dayjs().format('YYYY-MM-DD'),
                pagado: false,
                comentario: "",
                detalles: pedido.map((emp) => ({
                    id: emp.idDetalle || undefined,
                    deleted: emp.deleted || 0,
                    idEmpleado: emp.idEmpleado,
                    consumo: (emp.detalles || []).map((cons) => {
                        return ({
                            id: cons.id || undefined,
                            idProducto: cons.producto?.id || cons.idProducto,
                            estado: cons.estado || "PENDIENTE",
                            precio: parseFloat(cons.precio) || 0,
                            precioEditado: cons.precioEditado != null ? parseFloat(cons.precioEditado) : parseFloat(cons.precio) || 0,
                            cantidad: parseFloat(cons.cantidad) || 0,
                            esElaborado: cons.esElaborado || false,
                            motivoCancelacion: cons.motivoCancelacion || null,
                            comentario: cons.comentario || null,
                        })
                    }) || [],
                })),
            };

            const { data } = await savePedidoInterno({
                variables: { input },
            });

            if (data?.savePedidoInterno) {pedidoOriginal.current = null; handleSuccess()};
        } catch (err) {
            console.log("Error saving pedido:", err);
            if (err?.message) handleSnackbar(err?.message, 'warning');
        }
    };

    return (
        <SoftBox>
            {(pedido || []).filter(emp => emp?.deleted === 0).map((empleado) => (
                <EmpleadoDetalle
                    key={empleado.idEmpleado}
                    empleado={empleado}
                    setEmpleadoSelected={setEmpleadoSelected}
                    handleUpdateEstado={handleUpdateEstado}
                />
            ))}
            <SoftBox display="flex" flexDirection="column" alignItems="center" gap={2}>
                <SoftBox sx={{ width: "100%" }}>
                    <Collapse in={hayCambios} mountOnEnter unmountOnExit>
                        <SoftBox mt={2}>
                            <SoftButton
                                color="uproGreen"
                                circular
                                fullWidth
                                disabled={loadingSave}
                                onClick={handleSave}
                            >
                                {loadingSave ? (
                                    <CircularProgress size={15} color="inherit" />
                                ) : (
                                    <Icon sx={{ fontWeight: "light" }}>save</Icon>
                                )}
                                &nbsp;Guardar
                            </SoftButton>
                        </SoftBox>
                    </Collapse>
                </SoftBox>
                {/* <SoftBox sx={{ width: "100%" }}>
                    <SoftBox sx={{ width: "100%" }}>
                        <Collapse
                            in={(pedido || []).some(emp => (emp.detalles || []).length > 0) && pedidoString.current !== JSON.stringify(pedido)}
                            mountOnEnter
                            unmountOnExit>
                            <SoftButton
                                color="success"
                                circular
                                onClick={() => { }}
                                fullWidth
                            >
                                <Icon sx={{ fontWeight: "light" }}>done_all</Icon>
                                &nbsp;Finalizar y cerrar
                            </SoftButton>
                        </Collapse>
                    </SoftBox>
                </SoftBox> */}
            </SoftBox>
        </SoftBox >
    );
}

export default memo(ListDetallesConsumoInterno);